/** Features drawer: capability cards + demo catalog loaded from the server. */
import { features } from "./features";
import { strings, type Locale } from "./ui.strings";

const byId = <T extends HTMLElement>(id: string) => document.getElementById(id) as T;

export const setupFeaturesDrawer = ({ locale }: { locale: Locale }) => {
  const panel = byId<HTMLElement>("features-panel");
  const list = byId<HTMLDivElement>("features-list");

  for (const feature of features) {
    const card = document.createElement("article");
    card.className = "feature-card";
    const title = document.createElement("p");
    title.className = "feature-title";
    title.textContent = feature.title;
    const description = document.createElement("p");
    description.className = "feature-description";
    description.textContent = feature.description;
    const example = document.createElement("span");
    example.className = "feature-example";
    example.textContent = `« ${feature.example} »`;
    card.append(title, description, example);
    list.append(card);
  }

  // Demo catalog: searchable products list, loaded from the server
  const loadCatalog = async () => {
    const response = await fetch(`/api/products?lang=${locale}`);
    if (!response.ok) return;
    const { results } = (await response.json()) as {
      results: { name: string; price: string; requiresPrescription: boolean }[];
    };
    const title = document.createElement("p");
    title.className = "catalog-title";
    title.textContent = strings.catalog_title;
    list.append(title);
    for (const product of results) {
      const line = document.createElement("p");
      line.className = "catalog-item";
      line.textContent = `${product.name} — ${product.price}${product.requiresPrescription ? " (ordonnance)" : ""}`;
      list.append(line);
    }
  };
  loadCatalog().catch(console.error);

  const setOpen = ({ open }: { open: boolean }) => {
    panel.dataset.open = String(open);
  };
  byId<HTMLButtonElement>("features-toggle").addEventListener("click", () => setOpen({ open: true }));
  byId<HTMLButtonElement>("features-close").addEventListener("click", () => setOpen({ open: false }));
};
